import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router";
import { PageFallback } from "./components/Skeleton";
import HomePage from "./pages/home/HomePage";
import { RouteTransition } from "./RouteTransition";
import "./route-transition.css";

const AuthPage = lazy(() => import("./pages/auth/AuthPage"));
const CommunityPage = lazy(() => import("./pages/community/CommunityPage"));
const LibraryPage = lazy(() => import("./pages/library/LibraryPage"));
const MoodboardPage = lazy(() => import("./pages/moodboard/MoodboardPage"));
const SharedMoodboardPage = lazy(() => import("./pages/moodboard/SharedMoodboardPage"));
const WorkbenchPage = lazy(() => import("./pages/workbench/WorkbenchPage"));
const SitePage = lazy(() => import("./pages/site/SitePage"));
const HomePreviewPage = lazy(() => import("./pages/home-preview/HomePreviewPage"));

function App() {
  return (
    <RouteTransition>
      {(location) => (
        <Suspense fallback={<PageFallback />}>
          <Routes location={location}>
            <Route path="/" element={<HomePage />} />
            <Route path="/home-preview" element={<HomePreviewPage />} />
            <Route path="/home-preview/orbit" element={<HomePreviewPage variant="orbit" />} />
            <Route path="/moodboard" element={<MoodboardPage />} />
            <Route path="/moodboard/:id" element={<MoodboardPage />} />
            <Route path="/share/:id" element={<SharedMoodboardPage />} />
            <Route path="/workbench" element={<WorkbenchPage />} />
            <Route path="/library" element={<LibraryPage />} />
            <Route path="/community" element={<CommunityPage />}>
              <Route path=":noteId" element={null} />
            </Route>
            <Route path="/site/:code" element={<SitePage />} />
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/register" element={<AuthPage mode="register" />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </Suspense>
      )}
    </RouteTransition>
  );
}

export default App;
